import React from "react";
import image_1 from "../../images/afro-academy/Picture20.png";
import image_2 from "../../images/afro-academy/Picture21.png";
import image_3 from "../../images/afro-academy/Picture22.png";

const cardData = [
  {
    title: "Are you a trainer?",
    description:
      "Improve your knowledge and skills and expand your reach by selling your expertise as a local skilled professional.",
    img: image_1,
  },
  {
    title: "Are you an Organization?",
    description:
      "Are you looking for a trainer or facilitator? Grow your organization by hiring a local skilled professional, nearby and worldwide.",
    img: image_2,
  },
  {
    title: "Training of Trainers platform",
    description:
      "Ustaze.com offers an international market place for trainers everywhere to learn and earn with their expertise. Find and hire skilled local professionals to strengthen your organizational capacity and improve your business capabilities.",
    img: image_3,
  },
];

const ProfessionalCareer = () => {
  return (
    <section className="pt-7">
      <div className="text-center">
        <h1 className="fs-56 lh-64 gilroy-bold">USTAZE</h1>
        <h2 className="fs-28 lh-40 gilroy-bold">
          Build Your Professional Career
        </h2>
        <p className="fs-20">
          <a
            href="https://ustaze.com"
            target="_blank"
            rel="noreferrer"
            className="text-decoration-none text-dark"
          >
            Ustaze.com
          </a>
        </p>
      </div>

      <div className="container-fluid">
        <div className="me-13 ms-13">
          <div className="row g-3 justify-content-center">
            {cardData.map((data) => (
              <div
                className="col-12 col-sm-6 col-md-6 col-lg-4 text-center"
                key={data?.title}
              >
                <div
                  className="h-100 p-4 m-4 card-design-3"
                  style={{ boxShadow: "rgb(0 0 0 / 15%) 1.95px 1.95px 2.6px" }}
                >
                  <img
                    src={data?.img}
                    loading="lazy"
                    alt={data?.title}
                    className="img-fluid bg-american-yellow p-4 rounded"
                  />
                  <h3 className="fs-18 gilroy-bold mt-4">{data.title}</h3>
                  <p className="fs-16 lh-30 mt-4">{data.description}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default ProfessionalCareer;
